module.exports = __webpack_public_path__ + "static/media/ic_cajero_pin.952492c5.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_cajero_pin.webp
// module id = 200
// module chunks = 1